const states = {
  APPOINTMENT: 'FSM/PAGE/APPOINTMENT',
  BRAND_MODEL: 'FSM/PAGE/BRAND_MODEL',
  CALL_ME_BACK: 'FSM/PAGE/CALL_ME_BACK',
  CAR_DESTINATIONS: 'FSM/PAGE/CAR_DESTINATIONS',
  CONFIRMATION: 'FSM/PAGE/CONFIRMATION',
  ELIGIBILITY: 'FSM/PAGE/ELIGIBILITY',
  END_APPOINTMENT: 'FSM/PAGE/END_APPOINTMENT',
  END_MISSION: 'FSM/PAGE/END_MISSION',
  END_LOCATION: 'FSM/PAGE/END_LOCATION',
  EVENTS: 'FSM/PAGE/EVENTS',
  EVENTS_DETAILS: 'FSM/PAGE/EVENTS_DETAILS',
  SPECIFIC_EVENTS_DETAILS: 'FSM/SPECIFIC_EVENTS_DETAILS',
  HIGHWAY_PROCESS: 'FSM/PAGE/HIGHWAY_PROCESS',
  HIGHWAY_DIRECTION: 'FSM/PAGE/HIGHWAY_DIRECTION',
  LANDING_CLAIM: 'FSM/PAGE/LANDING_CLAIM',
  LANDING_SESSION: 'FSM/PAGE/LANDING_SESSION',
  LOCATION_DETAILS: 'FSM/PAGE/LOCATION_DETAILS',
  MILESTONE: 'FSM/PAGE/MILESTONE',
  MISSION_MONITORING: 'FSM/PAGE/MISSION_MONITORING',
  PREPARE_MISSION: 'FSM/PAGE/PREPARE_MISSION',
  SMS_CODE: 'FSM/PAGE/SMS_CODE',
  SPLASH_SCREEN: 'FSM/PAGE/SPLASH_SCREEN',
  VEHICLE_LOCATION: 'FSM/PAGE/VEHICLE_LOCATION',
  VOICE_EXIT: 'FSM/PAGE/VOICE_EXIT',
  WELCOME: 'FSM/PAGE/WELCOME',
  GDPR: 'FSM/PAGE/GDPR',
  PREVIOUS_CLAIM_HANDLING: 'FSM/PAGE/PREVIOUS_CLAIM_HANDLING',
  FNOL_APPOINTMENT: 'FSM/PAGE/FNOL_APPOINTMENT',
  FNOL_SITUATION_DETAILS: 'FSM/PAGE/FNOL_SITUATION_DETAILS',
  FNOL_CIRCUMSTANCES_DETAILS: 'FSM/PAGE/FNOL_CIRCUMSTANCES_DETAILS',
  FNOL_DAMAGES: 'FSM/PAGE/FNOL_DAMAGES',
  FNOL_ACCIDENT_STATEMENT: 'FSM/PAGE/FNOL_ACCIDENT_STATEMENT',
  FNOL_THIRD_PARTY_INFO: 'FSM/PAGE/FNOL_THIRD_PARTY_INFO',
  ADDITIONAL_TRANSPORTATION: 'FSM/PAGE/ADDITIONAL_TRANSPORTATION',
  OTP: 'FSM/PAGE/OTP',
  BENEFIT_SELECTION: 'FSM/PAGE/BENEFIT_SELECTION',
  RENTAL_CAR_WELCOME: 'FSM/PAGE/RENTAL_CAR_WELCOME',
  RENTAL_REGISTRATION: 'FSM/PAGE/RENTAL_REGISTRATION',
  RENTAL_ELIGIBILITY: 'FSM/PAGE/RENTAL_ELIGIBILITY',
  RENTAL_CAR_DRIVER_DETAILS: 'FSM/PAGE/RENTAL_CAR_DRIVER_DETAILS',
  RENTAL_CAR_CONFIRM_INFORMATION: 'FSM/PAGE/RENTAL_CAR_CONFIRM_INFORMATION',
  RENTAL_CAR_MISSION_CANCELLED_SUCCESSFULLY: 'FSM/PAGE/RENTAL_CAR_MISSION_CANCELLED_SUCCESSFULLY',
  RENTAL_INFORMATION: 'FSM/PAGE/RENTAL_INFORMATION',
  RENTAL_SUMMARY: 'FSM/PAGE/RENTAL_SUMMARY',
  RENTAL_VEHICLE_LOCATION_GARAGE_CONFIRM: 'FSM/PAGE/RENTAL_VEHICLE_LOCATION_GARAGE_CONFIRM',
  RENTAL_VEHICLE_OTHER_LOCATION: 'FSM/PAGE/RENTAL_VEHICLE_OTHER_LOCATION',
  RENTAL_VEHICLE_LOCATION_SUMMARY: 'FSM/PAGE/RENTAL_VEHICLE_LOCATION_SUMMARY',
  RENTAL_EXTENSION_VEHICLE_LOCATION: 'FSM/PAGE/RENTAL_EXTENSION_VEHICLE_LOCATION',
  RENTAL_EXTENSION_NOT_ELIGIBLE: 'FSM/PAGE/RENTAL_EXTENSION_NOT_ELIGIBLE',
  RENTAL_EXTENSION_DURATION: 'FSM/PAGE/RENTAL_EXTENSION_DURATION',
  RENTAL_EXTENSION_CONFIRMATION: 'FSM/PAGE/RENTAL_EXTENSION_CONFIRMATION',
};

export default states;
